import { isAfter, isBefore, parse } from 'date-fns'

const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const getEarlierDay = (day1: string, day2: string) => {
    const idx1 = days.indexOf(day1)
    const idx2 = days.indexOf(day2)

    // Calculate the difference, accounting for week wraparound
    const diff = (idx2 - idx1 + 7) % 7

    // If diff is 1, day2 comes after day1 (day1 is earlier)
    // If diff is 6, day2 comes before day1 (wrapping backwards)
    return diff === 1 ? day1 : day2
}

// The first date in before the second date
export const filterTimeIsBefore = (timeInQuestion: Date, timeFilter: string) => {
    if (timeFilter.indexOf('(') > -1) {
        const match = timeFilter.match(/(\d+):(\d+) \((\w+)\)/)

        if (match) {
            const hour = match[1]
            const minute = match[2]
            const day = match[3]

            const dateDay = timeInQuestion.toLocaleDateString('en-US', { weekday: 'short' })
            if (dateDay === day) {
                // it's the same day.
                const from = parse(`${hour}:${minute}`, 'HH:mm', timeInQuestion)
                return isBefore(timeInQuestion, from)
            } else {
                const earlierDay = getEarlierDay(dateDay, day)

                if (earlierDay === dateDay) {
                    // timeInQuestion day is earlier
                    return true
                }
                // different day, so always after
                return false
            }
        }
    } else {
        const from = parse(timeFilter, 'HH:mm', timeInQuestion)
        return isBefore(timeInQuestion, from)
    }
}

// The first date is after the second date
export const filterTimeIsAfter = (timeInQuestion: Date, timeFilter: string) => {
    if (timeFilter.indexOf('(') > -1) {
        const match = timeFilter.match(/(\d+):(\d+) \((\w+)\)/)

        if (match) {
            const hour = match[1]
            const minute = match[2]
            const day = match[3]

            const dateDay = timeInQuestion.toLocaleDateString('en-US', { weekday: 'short' })

            if (dateDay === day) {
                // it's the same day.
                const to = parse(`${hour}:${minute}`, 'HH:mm', timeInQuestion)
                return isAfter(timeInQuestion, to)
            } else {
                const earlierDay = getEarlierDay(dateDay, day)
                if (earlierDay === day) {
                    // timeInQuestion day is after
                    return true
                }
                // different day, so always before
                return false
            }
        }
    } else {
        const to = parse(timeFilter, 'HH:mm', timeInQuestion)
        return isAfter(timeInQuestion, to)
    }
}

export const filtersIsAfter = (timeFilterA: string, timeFilterB: string) => {
    if (timeFilterA.indexOf('(') > -1) {
        const parsedFrom = parse(timeFilterA, 'HH:mm (EEE)', new Date(0))
        const parsedValue = parse(timeFilterB, 'HH:mm (EEE)', new Date(0))

        return isAfter(parsedValue, parsedFrom)
    } else {
        const parsedFrom = parse(timeFilterA, 'HH:mm', new Date(0))
        const parsedValue = parse(timeFilterB, 'HH:mm', new Date(0))

        return isAfter(parsedValue, parsedFrom)
    }
}
